var lib_core  = require("lib-core");

var Editor2DController = require("../editor2D/editor2DController.js");

var HandlesStateMachine = require("./handlesStateMachine.js");
var HandlesModel = require("./handlesModel.js");

var HandlesController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(HandlesController, lib_core.Controller);
HandlesController.inject = {
    editor2DController : Editor2DController
};

module.exports = HandlesController;

HandlesController.prototype.createModel = function () {
    var editorModel = this.editor2DController.getModel();
    return new HandlesModel(editorModel);
};

HandlesController.prototype.createStateMachine = function () {
    var editorModel = this.editor2DController.getModel();
    return new HandlesStateMachine(this.root, editorModel, this.getModel());
};
